import { Plus } from "lucide-react";
import { marqueeItems } from "../content";

export const Marquee = () => {
  const row = [...marqueeItems, ...marqueeItems];
  return (
    <div className="overflow-hidden border-y border-black/10 bg-[#F7F7F5] py-5" aria-hidden="true" data-testid="marquee">
      <div className="animate-marquee flex w-max items-center gap-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-mono text-xs uppercase tracking-[0.24em] text-black/60">
            {item}
            <Plus size={14} className="text-[#1D4E89]" strokeWidth={2.5} />
          </span>
        ))}
      </div>
    </div>
  );
};
